import { nodeApiUrl } from './config'
import axios from './interceptor'
import * as moment from 'moment'
import qs from 'qs'

export default {
  async getDateRange (merchantId, deliveryType, shippingTime) {
    const forAll = false
    const queryString = qs.stringify({
      deliveryType, forAll, shippingTime,
    })
    const res = await axios.get(`${nodeApiUrl}/c/timeslot/takeaway/${merchantId}/date?${queryString}`)
    return res.data
  },
  async getTimeRange (merchantId, deliveryType, shippingTime, selectedDate) {
    const forAll = false
    const targetDate = moment(selectedDate)

    if (!deliveryType || !targetDate) return []

    const queryString = qs.stringify({
      deliveryType, forAll, shippingTime,
    })
    const res = await axios.get(`${nodeApiUrl}/c/timeslot/takeaway/${merchantId}/${selectedDate}/time?${queryString}`)
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/timeslot.js